import {
  START_REQUEST,
  STOP_REQUEST,
  FETCH_PROFILE_START,
  FETCH_PROFILE_SUCCESS,
  FETCH_PROFILE_FAILURE,
  FETCH_BILLINGINFO_START,
  FETCH_BILLINGINFO_SUCCESS,
  FETCH_BILLINGINFO_FAILURE,
  FETCH_INTEGRATIONS_START,
  FETCH_INTEGRATIONS_SUCCESS,
  FETCH_INTEGRATIONS_FAILURE,
  INVALIDATE_GOOGLE_INTEGRATION,
  FETCH_USER_SETTINGS_SUCCESS,
  UPDATE_USER_SETTINGS_SUCCESS,
} from '../actions/profileActions';

export default (state = { profile: {}, billingInfo: null, integrations: {}, plans: [], userSettings: {}, profileError: false, billingInfoError: false, integrationsError: false }, action) => {
  switch (action.type) {
  case START_REQUEST: {
    return {
      ...state,
      loading: true,
    };
  }
  case STOP_REQUEST: {
    return {
      ...state,
      loading: false,
    };
  }
  case FETCH_PROFILE_START: {
    return {
      ...state,
      loading: true,
      profileError: false,
    };
  }
  case FETCH_PROFILE_SUCCESS: {
    const integrations = (action.profile && action.profile.integrations) || {};
    return {
      ...state,
      profile: action.profile,
      integrations,
      profileError: false,
    };
  }
  case FETCH_PROFILE_FAILURE: {
    return {
      ...state,
      profileError: true,
    };
  }
  case FETCH_BILLINGINFO_START: {
    return {
      ...state,
      billingInfo: null,
      billingInfoError: false,
    };
  }
  case FETCH_BILLINGINFO_SUCCESS: {
    return {
      ...state,
      billingInfo: action.billingInfo,
      billingInfoError: false,
    };
  }
  case FETCH_BILLINGINFO_FAILURE: {
    return {
      ...state,
      billingInfoError: true,
    };
  }
  case FETCH_INTEGRATIONS_SUCCESS: {
    return {
      ...state,
      integrations: action.integrations,
      integrationsError: false,
    };
  }
  case INVALIDATE_GOOGLE_INTEGRATION: {
    const integrations = { ...state.integrations };
    const profileIntegrations = { ...state.profile.integrations };
    delete integrations.google;
    delete profileIntegrations.google;
    return {
      ...state,
      integrations,
      profile: { ...state.profile, integrations: profileIntegrations },
    };
  }
  case FETCH_INTEGRATIONS_START: {
    return {
      ...state,
      loading: true,
      integrationsError: false,
    };
  }
  case FETCH_INTEGRATIONS_FAILURE: {
    return {
      ...state,
      integrationsError: true,
    };
  }
  case FETCH_USER_SETTINGS_SUCCESS: {
    return {
      ...state,
      userSettings: action.userSettings,
    };
  }
  case UPDATE_USER_SETTINGS_SUCCESS: {
    return {
      ...state,
      userSettings: action.userSettings,
    };
  }
  default:
    return state;
  }
};
